if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			this.addEventListener('click', this.onQuickAddSubmitActivation.bind(this), true);
			this.addEventListener('touchend', this.onQuickAddSubmitActivation.bind(this), {
				capture: true,
				passive: false,
			});
			this.addEventListener('keydown', this.onQuickAddSubmitActivation.bind(this), true);
			this.addEventListener('focusin', this.onQuickAddFocusIn.bind(this), true);
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

			if (preventFocus) this.openedBy = null;
			super.hide();
			this.modalContent.innerHTML = '';
			if (preventFocus && cartDrawer) {
				cartDrawer.setOutsideInert(true);
			}
		}

		show(opener) {
			opener.classList.add('loading');

			const announcer = document.getElementById('quick-add-announcer');
			if (announcer) {
				announcer.textContent = opener.dataset.loadingAnnouncement || '';
			}

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			fetch(opener.getAttribute('data-product-url'))
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();
					super.show(opener);
				})
				.finally(() => {
					if (announcer) announcer.textContent = '';
					opener.classList.remove('loading');

					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}

					var slider = new Swiper('.quick-add-modal .js-media-list', {
						slidesPerView: 1,
						autoHeight: true,
						navigation: {
							nextEl: '.swiper-btn--next',
							prevEl: '.swiper-btn--prev',
						},
						pagination: {
							el: ".swiper-pagination",
							clickable: true,
						},
						on: {
							slideChange: function () {
								window.pauseAllMedia();
							}
						}
					});
				});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;

			// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			// Read more button
			const moreBtn = document.createElement('a');
			moreBtn.textContent = `${theme.quickviewMore}`;
			moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
			moreBtn.setAttribute('class', 'product__read-more button--simple full-unstyled-link h6');
			element.querySelector('.product__info-container').appendChild(moreBtn);
		}

		onQuickAddSubmitActivation(event) {
			if (
				event.type === 'keydown' &&
				!['Enter', ' ', 'Spacebar'].includes(event.key) &&
				!['Enter', 'Space', 'NumpadEnter'].includes(event.code)
			) return;
			if (!event.target.closest) return;

			const submitButton = event.target.closest('.product-form__submit');
			if (!submitButton || !this.contains(submitButton)) return;

			event.preventDefault();
			this.submitQuickAddForm(submitButton);
		}

		onQuickAddFocusIn(event) {
			if (!event.target.closest) return;

			const submitButton = event.target.closest('.product-form__submit');
			if (submitButton && this.contains(submitButton)) {
				this.lastFocusedSubmitButton = submitButton;
				return;
			}

			const closeButton = event.target.closest('[id^="ModalClose-"]');
			if (closeButton && this.lastFocusedSubmitButton && this.contains(this.lastFocusedSubmitButton)) {
				const button = this.lastFocusedSubmitButton;
				this.lastFocusedSubmitButton = null;
				this.submitQuickAddForm(button);
				return;
			}

			this.lastFocusedSubmitButton = null;
		}

		submitQuickAddForm(submitButton) {
			const productForm = submitButton.closest('product-form');
			if (!productForm || typeof productForm.requestSubmitFromButton !== 'function') return;

			productForm.requestSubmitFromButton();
		}

		removeDOMElements() {
			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}
	});
}
